<app-carousel></app-carousel>
<app-influenser-natural></app-influenser-natural>
<app-pillars></app-pillars>
<app-whats-being-influenser></app-whats-being-influenser>
<!-- <app-join-the-movement></app-join-the-movement> -->
<app-banner></app-banner>
<app-gallery></app-gallery>

